import { RouterProvider } from 'react-router/dom';
import { routers } from '@/router';
import { SWRConfig } from 'swr';
import { ToastRenderer } from '@/widgets/toast';
import { ConfirmRenderer } from '@/widgets/confirm';
import { LoadingRenderer } from './widgets/loading';

export default function App() {
  return (
    <SWRConfig value={{ revalidateOnFocus: false }}>
      <RouterProvider router={routers} />
      <ToastRenderer />
      <ConfirmRenderer />
      <LoadingRenderer />
    </SWRConfig>
  );
}
